import a from "react";
import m from "./index164.mjs";
import { Column as r } from "./index135.mjs";
import { formatPrice as s } from "./index110.mjs";
import { useAtomValue as n } from "jotai";
import { cartItemsAtom as c, giftCardsAtom as u } from "./index34.mjs";
const i = ({
  label: e,
  price: t
}) => /* @__PURE__ */ a.createElement("div", { className: m["cart-summary"] }, /* @__PURE__ */ a.createElement(
  r,
  {
    title: I18n.t("booking_engine.information.your_stay"),
    value: e,
    classes: m.stay,
    valueStyle: m.stay_value
  }
), /* @__PURE__ */ a.createElement(
  r,
  {
    title: I18n.t("booking_engine.room.total"),
    value: t,
    classes: m.total,
    valueStyle: m.total_value
  }
)), g = ({ giftCards: e, totalPrice: t, currency: l }) => {
  var o;
  return /* @__PURE__ */ a.createElement(
    i,
    {
      label: e.length > 1 ? `${e.length} ${I18n.t("booking_engine.gift_cards.title")}` : ((o = e[0]) == null ? void 0 : o.name) ?? "",
      price: s(parseFloat(t), l)
    }
  );
}, p = ({ cartItems: e, totalPrice: t, currency: l }) => {
  var o;
  return /* @__PURE__ */ a.createElement(
    i,
    {
      label: e.length > 1 ? `${e.length} ${I18n.t("booking_engine.rooms")}` : ((o = e[0]) == null ? void 0 : o.roomName) ?? "",
      price: s(parseFloat(t), l)
    }
  );
}, d = ({
  totalPrice: e,
  currency: t
}) => {
  const l = n(c), o = n(u);
  return o.length > 0 ? /* @__PURE__ */ a.createElement(
    g,
    {
      giftCards: o,
      totalPrice: e,
      currency: t
    }
  ) : /* @__PURE__ */ a.createElement(
    p,
    {
      cartItems: l,
      totalPrice: e,
      currency: t
    }
  );
};
export {
  d as CollapsedHeader
};
